import React from 'react';
import { connect } from 'react-redux';
import animator from '../../../../../helpers/animator';
import CommentCard from '../CommentCard';
import addIcon from '../../../../../assets/images/add-icon.svg';
import dataModel from '../../../../../models/DataModel';
import './CommentsDropDown.scss';
import '../SubHeader.scss';
import moment from 'moment';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import Input from '../../../../../components/Input';
import Textarea from '../../../../../components/Textarea';

class CommentsDropDown extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      addNewComment: false,
      selectedComment: this.props.task && this.props.task.comments ?
        this.props.task.comments[0] : (this.props.project && this.props.project.comments ?
          this.props.project.comments[0] : { caption: '', body: '' }),
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate() {
    const { project, task } = this.props;
    const { selectedComment } = this.state;
    if (task) {
      if (!selectedComment && task.comments.length > 0) {
        this.setState({ selectedComment: task.comments[task.comments.length - 1] });
      }
      else if ((!task.comments || task.comments.length == 0) && selectedComment) {
        this.setState({ selectedComment: null });
      }
      else if (selectedComment && task.comments.length > 0 && task.comments.indexOf(selectedComment) < 0) {
        this.setState({ selectedComment: task.comments[task.comments.length - 1] });
      }
    }
    else if (project) {
      if (!selectedComment && project.comments.length > 0) {
        this.setState({ selectedComment: project.comments[project.comments.length - 1] });
      }
      else if ((!project.comments || project.comments.length == 0) && selectedComment) {
        this.setState({ selectedComment: null });
      }
      else if (selectedComment && project.comments.length > 0 && project.comments.indexOf(selectedComment) < 0) {
        this.setState({ selectedComment: project.comments[project.comments.length - 1] });
      }
    }
  }

  handleClose() {
    const { handleCloseDropDown } = this.props;
    if (handleCloseDropDown) {
      handleCloseDropDown();
    }
  }

  handleAddComment() {
    this.setState({ addNewComment: true, caption: '', body: '' });
  }

  handleEscape() {
    this.setState({ addNewComment: false });
  }

  handleCancel() {
    this.setState({ addNewComment: false, editComment: false });  
  } 

  handleSave() {
    const { project, task } = this.props;
    if (this.state.addNewComment) {
      this.editingComment.commentable_type = task ? 'Task' : 'Project';
      this.editingComment.commentable_id = task ? task.id : project.id;
      dataModel.commentsDAO.createComment(this.editingComment);
    }
    else if (this.state.editComment) {
      dataModel.commentsDAO.updateComment(this.editingComment);
    }
    this.setState({ addNewComment: false, editComment: false, selectedComment: this.editingComment, editingComment: null });
  }
  
  handleCaptionChange(e) {
    this.editingComment.caption = e.target.value;
    this.setState({ caption: e.target.value });
  }

  handleCommentBodyChange(e) {
    this.editingComment.body = e.target.value;
    this.setState({ body: e.target.value });
  }

  handleCommentSelection(comment) {
    this.setState({ selectedComment: comment });  
  } 

  handleMenuSelected(option) {
    const comment = option.comment;
    if (option.type == 'edit') {
      this.editingComment = comment;
      this.setState({ editComment: true, caption: this.editingComment.caption, body: this.editingComment.body });
    }
    else if (option.type == 'delete') {
      dataModel.commentsDAO.deleteComment(comment);
    }
  }
  
  render() {
    const { project, task, height, permissions } = this.props;
    if (!project && !task) {
      return null;
    }

    const { selectedComment, addNewComment, editComment, caption, body } = this.state;

    // parse the comments
    
    let newComment = null;
    if (permissions.canLimitedCommentCrud || permissions.canPmCommentCrud) {
      const captionText = task ? this.textMap.addNewTaskComment : this.textMap.addNewProjectComment;
      newComment = < div key="add-user-0" className="add-comment"
        onClick={this.handleAddComment}>
        <img className="add-comment-button" src={addIcon} alt="Add Comment" />
        <div className="add-comment-label">{captionText}</div>
      </div>;
    }

    let keyInc = 1;    
    const comments = task ? task.comments : project.comments;
    const commentsList = comments ? comments.map(comment => {
      let menuOptions = null;
      
      let permitted = false;
      if (task) {
        permitted = permissions.isSuperUser || (permissions.canLimitedCommentCrud &&
          this.props.currentUser.id == (comment.user ? comment.user.id : comment.user_id));
      }
      else{
        permitted = permissions.isSuperUser || (permissions.canLimitedCommentCrud &&
          this.props.currentUser.id == (comment.user ? comment.user.id : comment.user_id)) ||
          (permissions.canPmCommentCrud && this.props.currentUser.id == project.project_manager.id);
      }
      if (permitted) {
        menuOptions = [{
          type: 'delete',
          name: 'Archive Comment',
          comment: comment,
        },
          {
            type: 'edit',
            name: 'Edit Comment',
            comment: comment,
          },
        ];
      }

      let user = comment.user;
      if (!user) {
        return null;
      }
      const selected = comment == selectedComment;
      const date = moment(new Date(comment.created_at));
      const dateStr = date.format('MMM D, YYYY h:mm:ss a');
      const card = <div key={keyInc++} className={'comment-card' + (selected ? ' selected': '')}>
        <CommentCard width={219} height={40} selected={selected}
          top={0} menuOptions={menuOptions} handleMenuSelected={this.handleMenuSelected}
          right={0} caption={comment.caption} turnOffBorder={true} hideDots={!menuOptions}
          date={dateStr} handleCardSelection={this.handleCommentSelection} data={comment}
        /></div>;
      return card;
    }) : null;

    let commentText = selectedComment ? selectedComment.body : 'None to Display';
    const paragraphs = commentText.split('\n');
    let para = 1;
    const commentParagraphs = paragraphs.map(paragraph => {
      return <p key={para++}><span>{paragraph}</span></p>;
    });

    const author = selectedComment ? <div className="author">{'--' + (selectedComment && selectedComment.user ? selectedComment.user.first_name + ' ' + selectedComment.user.last_name : '')}</div> : null;
    let commentDisplay = <div className="comment-display">
      <div className="comment-caption">{selectedComment ? selectedComment.caption: ''}</div>
      <div className="comment-body">
        {commentParagraphs}
      </div>  
      {author}
    </div>;

    if (addNewComment || editComment) {
      if (editComment) {
        this.editingComment = selectedComment;
      }
      else {
        this.editingComment = { user_id: this.props.currentUser.id, caption: caption, body: body };
      }
      commentDisplay = <div className="comment-add-edit">
        <div className="comment-caption">
          <div className="comment-label">COMMENT CAPTION</div>
          <Input className="comment-caption-input" onChange={this.handleCaptionChange} onBlur={this.handleCaptionChange}
            value={caption}/>
        </div>
        <div className="comment-body">
          <div className="comment-label">COMMENT BODY</div>
          <Textarea className="comment-body-input" onChange={this.handleCommentBodyChange} onBlur={this.handleCommentBodyChange}
            value={body ? body : ''}/>
        </div>
        <div className="button-footer">
          <div className="cancel-button button" onClick={this.handleCancel}>CANCEL</div>
          <div className="save-button button" onClick={this.handleSave}>SAVE</div>
        </div>
      </div>;
    }

    let style = {};
    if (height) {
      style.height = height;
    }

    return (
      <div id="commentsDisplay" className="comments-container dropdown-container" style={style}>
        <div className="close-button" onClick={this.handleClose}>
        </div>
        <div className="left-column">
          {newComment}
          {commentsList}
        </div>
        <div className="right-column">
          {commentDisplay}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsDropDown);




// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/SubHeader/CommentsDropDown/index.js